<template lang="pug">
    .col-md-6.col-sm-6.col-xs-12.box-parent-lesson
        .box-info
            .avatar
                img(:src="lesson.avatar" v-if="lesson.avatar && lesson.avatar !== null && lesson.avatar.length")
                img(src="../../../../assets/images/faces/ic_AvatarDefault.svg" v-else)
            .item-info
                a()
                  span.fullname {{lesson.fullname}}
                router-link(:to="{ name: 'page_public', params: {subject_id: lesson.subject_id, currentPage: 1, front_top: 0}}")
                  span.subjects {{lesson.subject_name}}
                router-link(:to="{ name: 'page_public', params: {grade_id: lesson.grade_id, currentPage: 1, front_top: 0}}")
                  span.grades {{lesson.grade_name}}
            .clearfix
        .box-item-lesson
            router-link(:to="{ name: 'page_lesson_detail', params: {id: lesson.id}}")
              img(:src="lesson.banner[0]" v-if="lesson.banner && lesson.banner !== null && lesson.banner.length > 0")
              img(src="../../../../assets/Obee_Logo_140@2x.png" v-else)
            .overlay(@click="viewDetail(lesson.id)")
            .item-title
              router-link(v-if="this.$store.getters.isLoggedIn" :to="{ name: 'page_lesson_detail', params: {id: lesson.id}}")
                span {{lesson.name}}
              a(@click="viewDetail(lesson.id)" v-else)
                span {{lesson.name}}
        .item-social
          span
            i.like.fa(@click="likeLesson(lesson.id)" v-if="!liked || !$store.getters.user")
              img(src="../../../../assets/images/home/ic_like_outline.svg")
              | {{ $mycontroller.numberWithCommas(lesson.count_like) }}
            i.like.fa(@click="unLikeLesson(lesson.id)" v-if="liked && $store.getters.user")
              img(src="../../../../assets/images/home/ic_like.svg")
              | {{ $mycontroller.numberWithCommas(lesson.count_like) }}
          span
            i.fa
              img(src="../../../../assets/images/home/ic_comment.svg")
              | {{ $mycontroller.numberWithCommas(lesson.count_comment) }}
          span
            i.fa
              img(src="../../../../assets/images/home/ic_share.svg")
              | {{ $mycontroller.numberWithCommas(lesson.count_share) }}
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import store from '../../../../store'
import LoginModal from '@/components/Account/LoginModal'
export default {
  props: {
    lesson: Object,
    obj_id: Number
  },
  data() {
    return {
      object_id: this.obj_id,
      isSucess: false,
      liked: false
    }
  },
  computed: {
    changeData(id) {
      // console.log('id ', id)
      return id
    }
  },
  methods: {
    viewDetail(id) {
      this.$router.push({name: 'page_lesson_detail', params: {id: id}})
    },
    likeLesson(id) {
      if (!this.$store.getters.isLoggedIn) {
        this.$store.commit('setIsHomePage', true)
        let scrollTop = this.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        params = Object.assign(params, {currentPage: this.$parent.currentPage})
        if (this.isMobile()) {
          try {
            this.$modal.show(LoginModal, {params: params}, {
              // width: '43%',
              height: 'auto',
              classes: ['col-6'],
              adaptive: true,
              resize: true,
              clickToClose: false
            })
          } catch (e) {}
        } else {
          this.$store.commit('setIsHomePage', false)
          this.$router.push({name: 'Login', params: params})
        }
      } else {
        if (!this.isSucess) {
          this.isSucess = true
          this.$apollo.mutate({
            mutation: gql(graphql.LIKE_LESSONS_HOME),
            variables: {
              object_id: id,
              user_id: store.getters.user
            },
            update: (store, { data: { insert_likes_lesson } }) => {
              if (insert_likes_lesson.affected_rows) {
                this.liked = true
                this.lesson.count_like++
              }
              this.isSucess = false
            }
          })
        }
      }
    },
    unLikeLesson(id) {
      if (!this.$store.getters.isLoggedIn) {
        this.$store.commit('setIsHomePage', true)
        let scrollTop = this.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        params = Object.assign(params, {currentPage: this.$parent.currentPage})
        if (this.isMobile()) {
          try {
            this.$modal.show(LoginModal, {params: params}, {
              // width: '43%',
              height: 'auto',
              classes: ['col-6'],
              adaptive: true,
              resize: true,
              clickToClose: false
            })
          } catch (e) {}
        } else {
          this.$store.commit('setIsHomePage', false)
          this.$router.push({name: 'Login', params: params})
        }
      } else {
        if (!this.isSucess) {
          this.isSucess = true
          this.$apollo.mutate({
            mutation: gql(graphql.UNLIKE_LESSONS_HOME),
            variables: {
              object_id: id,
              user_id: store.getters.user
            },
            update: (store, { data: { delete_likes_lesson } }) => {
              if (delete_likes_lesson.affected_rows) {
                this.liked = false
                if (this.lesson.count_like > 0) this.lesson.count_like--
              }
              this.isSucess = false
            }
          })
        }
      }
    },
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  async mounted () {
    this.liked = false
    if (this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null) {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_LESSONS_LIKE_HOME),
        fetchPolicy: 'no-cache',
        variables: {
          object_id: this.object_id,
          user_id: store.getters.user
        }})
      this.liked = data.likes_lesson.length > 0
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">

</style>




// WEBPACK FOOTER //
// Item.vue?0e60eaaa